import { render, staticRenderFns } from "./VerificationOld.vue?vue&type=template&id=1b5b78ce&scoped=true&"
import script from "./VerificationOld.vue?vue&type=script&lang=ts&"
export * from "./VerificationOld.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5b78ce",
  null
  
)

export default component.exports